import script from "./ae-expandable-image.vue?vue&type=script&setup=true&lang=js"
export * from "./ae-expandable-image.vue?vue&type=script&setup=true&lang=js"

import "./ae-expandable-image.vue?vue&type=style&index=0&id=19d4697c&lang=css"

const __exports__ = script;

export default __exports__